import React, { useState, useEffect } from 'react';
import { Building2, Save, Loader2, Image as ImageIcon } from 'lucide-react';
import { api } from '../../api';

export default function CompanyPage() {
  const [form, setForm] = useState({
    name: '', address: '', zip: '', city: '',
    email: '', phone: '', org_nr: '', logo: null
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.getCompany()
      .then(data => setForm({ ...form, ...data }))
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true); setMessage('');
    try {
      await api.updateCompany(form);
      setMessage('Profil sparad!');
    } catch (e) {
      setMessage('Fel: ' + e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleLogo = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => setForm({ ...form, logo: ev.target.result });
    reader.readAsDataURL(file);
  };

  const f = (field) => ({ value: form[field] || '', onChange: e => setForm({ ...form, [field]: e.target.value }) });

  if (loading) return <div className="flex justify-center py-12"><Loader2 className="animate-spin text-blue-600" size={32} /></div>;

  return (
    <div className="max-w-2xl space-y-6">
      <h2 className="text-2xl font-black flex items-center gap-3">
        <Building2 className="text-blue-600" /> Företagsprofil
      </h2>

      <form onSubmit={handleSave} className="bg-white rounded-2xl border border-slate-200 p-6 space-y-6">
        {/* Logotyp */}
        <div className="flex items-center gap-6 p-4 bg-slate-50 rounded-2xl border border-slate-100">
          <div className="w-24 h-24 border-2 border-dashed border-slate-300 rounded-2xl flex items-center justify-center bg-white overflow-hidden flex-shrink-0">
            {form.logo ? (
              <img src={form.logo} alt="Logotyp" className="w-full h-full object-contain" />
            ) : (
              <ImageIcon className="text-slate-300" size={32} />
            )}
          </div>
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase block mb-2">Logotyp</label>
            <input type="file" accept="image/*" onChange={handleLogo}
              className="text-xs text-slate-500 file:mr-3 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-black file:bg-blue-600 file:text-white" />
            {form.logo && (
              <button type="button" onClick={() => setForm({ ...form, logo: null })}
                className="block mt-2 text-xs text-red-500 hover:underline">Ta bort logotyp</button>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <label className="text-xs font-bold text-slate-500 uppercase">Företagsnamn</label>
            <input {...f('name')} className="w-full mt-1 p-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500" placeholder="Mitt Företag AB" />
          </div>
          <div className="md:col-span-2">
            <label className="text-xs font-bold text-slate-500 uppercase">Gatuadress</label>
            <input {...f('address')} className="w-full mt-1 p-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase">Postnummer</label>
            <input {...f('zip')} className="w-full mt-1 p-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase">Stad</label>
            <input {...f('city')} className="w-full mt-1 p-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase">E-post</label>
            <input type="email" {...f('email')} className="w-full mt-1 p-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase">Telefon</label>
            <input {...f('phone')} className="w-full mt-1 p-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="text-xs font-bold text-slate-500 uppercase">Org.nummer</label>
            <input {...f('org_nr')} className="w-full mt-1 p-3 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500" placeholder="556677-8899" />
          </div>
        </div>

        {message && (
          <p className={`text-sm p-3 rounded-lg ${message.startsWith('Fel') ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>
            {message}
          </p>
        )}

        <button type="submit" disabled={saving}
          className="w-full bg-blue-600 text-white py-4 rounded-xl font-black flex items-center justify-center gap-2 shadow-xl">
          {saving ? <Loader2 className="animate-spin" size={20} /> : <><Save size={20} /> Spara profil</>}
        </button>
      </form>
    </div>
  );
}
